// extracted by mini-css-extract-plugin
module.exports = {"icon":"UnauthorizedAgentsCounter__icon--HN","counter":"UnauthorizedAgentsCounter__counter--rK"};